// setOperationChatroomData.js
'use strict';
import { goBack } from 'redux-first-history';

import {
  MERGE_OPERATION_DATA,
  SET_LIST_ITEMS,
  CLEAR_NETWORKING_NODES,
} from '../ActionTypes.js';
import fetchChatroomSearch from '../action/fetchChatroomSearch.js';
import fetchChatroomMessagesWithDynamicLimit from '../action/fetchChatroomMessagesWithDynamicLimit.js';
import getListData from '../selector/getListData.js';
import getDynamicPageLimit from '../resource/getDynamicPageLimit.js';

/**
 * Set operation chatroom data
 * @kind action
 * @param {string} {key} - which key will be updated.
 * @param {object} {payload} - payload.
 * @return {Promise} Action promise.
 */
const setOperationChatroomData =
  ({ key, payload = {} }) =>
  async (dispatch, getState) => {
    if (key === 'searchQuery') {
      const { query, chatroomId } = payload;
      const replacedQuery = query?.replace(/[\b]/g, ' ');
      dispatch({
        type: MERGE_OPERATION_DATA,
        payload: {
          selectPath: ['chatroom'],
          data: {
            query: replacedQuery,
          },
        },
      });
      dispatch({
        type: CLEAR_NETWORKING_NODES,
        payload: {
          selectPaths: [['chatroom', chatroomId, 'search']],
        },
      });
      dispatch({
        type: SET_LIST_ITEMS,
        payload: {
          selectPath: ['chatroom', chatroomId, 'search'],
          itemIds: [],
        },
      });
      const url = new URL(location.href);
      if (replacedQuery) {
        url.searchParams.set('q', replacedQuery);
      } else {
        url.searchParams.delete('q');
      }
      history.replaceState(history.state, '', `${url.pathname}${url.search}`);
      return dispatch(
        fetchChatroomSearch({
          chatroomId,
          query: replacedQuery,
        })
      );
    }
    if (key === 'highlightedMessageId') {
      const { messageId } = payload;
      return dispatch({
        type: MERGE_OPERATION_DATA,
        payload: {
          selectPath: ['chatroom'],
          data: {
            highlightedMessageId: messageId,
          },
        },
      });
    }
    if (key === 'clickSearchMessage') {
      const { chatroomId, messageId, index } = payload;
      const totalCount = getListData(
        getState(),
        ['chatroom', chatroomId, 'messages'],
        'totalCount'
      );
      if (totalCount === undefined) {
        await dispatch(
          fetchChatroomMessagesWithDynamicLimit({ id: chatroomId })
        );
      }

      const dynamicPageLimit = getDynamicPageLimit(
        getListData(
          getState(),
          ['chatroom', chatroomId, 'messages'],
          'totalCount'
        )
      );
      dispatch({
        type: MERGE_OPERATION_DATA,
        payload: {
          selectPath: ['chatroom'],
          data: {
            searchMessageId: messageId,
            // search index starts from 0
            // page starts from 1
            searchPage: Math.floor(index / dynamicPageLimit) + 1,
          },
        },
      });
      return dispatch(goBack());
    }
    if (key === 'clearSearchMessage') {
      return dispatch({
        type: MERGE_OPERATION_DATA,
        payload: {
          selectPath: ['chatroom'],
          data: {
            searchMessageId: undefined,
            searchPage: undefined,
          },
        },
      });
    }
    if ('replyMessageId' === key) {
      const { replyMessageId } = payload;
      return dispatch({
        type: MERGE_OPERATION_DATA,
        payload: {
          selectPath: ['chatroom'],
          data: {
            replyMessageId,
          },
        },
      });
    }
    if (key === 'clickChatroomMediaMessage') {
      const { messageId, pageNumber } = payload;
      return dispatch({
        type: MERGE_OPERATION_DATA,
        payload: {
          selectPath: ['chatroom'],
          data: {
            searchMessageId: messageId,
            searchPage: pageNumber,
          },
        },
      });
    }
    if (key === 'clickChatroomMediaLibrary') {
      const { scrollTop } = payload;
      return dispatch({
        type: MERGE_OPERATION_DATA,
        payload: {
          selectPath: ['chatroom'],
          data: {
            scrollTop,
          },
        },
      });
    }
    return dispatch({ type: '' });
  };

export default setOperationChatroomData;
